"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSysLink = void 0;
const isSysLink = (link) => {
    return link !== null && typeof link === 'object' && 'sys' in link && 'id' in link.sys;
};
exports.isSysLink = isSysLink;
//# sourceMappingURL=checks.js.map